import { ComponentProps } from 'react';
import { PostHogProvider as PostHogProviderReact } from 'posthog-js/react';
import { FeatureFlagsProvider } from './FeatureFlagsProvider';

type PostHogProps = {
  children: React.ReactNode;
  token: string;
  options?: ComponentProps<typeof PostHogProviderReact>['options'];
  showByDefault?: boolean;
};

export const PostHogProvider = ({
  token,
  options,
  children,
  showByDefault = false,
}: PostHogProps) => {
  return (
    <PostHogProviderReact apiKey={token} options={options}>
      <FeatureFlagsProvider showByDefault={showByDefault}>
        {children}
      </FeatureFlagsProvider>
    </PostHogProviderReact>
  );
};
